import { RemoteCNAES } from "../../../../data/usecases/cnaes/remote-cnaes";
import { CNAES } from "../../../../domain/models/cnae";
import { makeAxiosHttpClient } from "../../http/axios-http-client-factory";

export const makeRemoteCNAES = (): CNAES =>
  new RemoteCNAES("/cnaes", makeAxiosHttpClient());
